import { motion } from "framer-motion";
import { ROLE_DATA } from "../../data/roles.js";
import { scaleIn } from "../../animations/variants.js";
import { RoleBadge } from "./RoleBadge.jsx";

export function RoleCardFull({ roleId, playerName, lang }) {
  const role = ROLE_DATA[roleId];
  if (!role) return null;
  const name  = lang === "fr" ? role.frenchName  : role.englishName;
  const instr = lang === "fr" ? role.frenchInstruction : role.englishInstruction;
  const obj   = lang === "fr" ? role.frenchObjective   : role.englishObjective;

  const alignLabel = role.alignment === "village"  ? (lang === "fr" ? "Village" : "Village")
    : role.alignment === "werewolf" ? (lang === "fr" ? "Loup-Garou" : "Werewolf")
    : (lang === "fr" ? "Neutre" : "Neutral");

  return (
    <motion.div
      variants={scaleIn} initial="initial" animate="animate"
      className={`w-full max-w-xs mx-auto rounded-3xl border-2 ${role.border}
        bg-gradient-to-b ${role.gradient} p-6 shadow-2xl ${role.glow}
        flex flex-col items-center gap-4`}>

      <div className="w-28 aspect-[3/4] rounded-2xl border border-white/10 bg-black/30
        flex flex-col items-center justify-center gap-1 overflow-hidden">
        {role.imageUrl
          ? <img src={role.imageUrl} alt={role.englishName} className="w-full h-full object-cover" />
          : <span className="text-5xl">{role.emoji}</span>}
      </div>

      <div className="text-center">
        {playerName && <p className="text-white/40 text-xs uppercase tracking-[0.15em] mb-1">{playerName}</p>}
        <h2 className="text-2xl font-bold text-white">{name}</h2>
        <div className="flex items-center justify-center gap-2 mt-1">
          <p className={`text-xs px-2 py-0.5 rounded-full inline-block ${role.badge} text-white/80`}>
            {alignLabel}
          </p>
          <RoleBadge roleBadge={role.roleBadge} lang={lang} />
        </div>
      </div>

      <div className="bg-black/30 rounded-2xl p-4 w-full">
        <p className="text-white/90 text-sm leading-relaxed text-center">{instr}</p>
      </div>

      <div className="w-full text-center">
        <p className="text-white/30 text-[10px] uppercase tracking-widest mb-1">
          {lang === "fr" ? "Objectif" : "Objective"}
        </p>
        <p className="text-amber-300 text-xs font-semibold">🎯 {obj}</p>
      </div>
    </motion.div>
  );
}
